import React from 'react';

import { Button } from 'semantic-ui-react'

import { auth } from '../../firebase';

const SignOutButton = () =>
  <Button
    inverted
    content="Sign Out"
    icon="sign out alternate"
    labelPosition='left'
    color="red"
    onClick={auth.doSignOut}
  />

export default SignOutButton;



// WEBPACK FOOTER //
// ./src/components/SignOut/index.js